import React from 'react';
import { CDBTable, CDBTableBody, CDBTableHeader } from 'cdbreact';
import { formatCurrency, formatDate, getStatusConfig } from '../utils/recurringHelpers';

export const RecurringTable = ({ items, onCancel }) => {
    return (
        <CDBTable 
            hover 
            responsive 
            maxHeight="60vh" 
            scrollY 
            className="flex-grow-1"
            style={{ 
                fontSize: '15px', 
                fontFamily: 'Montserrat, sans-serif',
                backgroundColor: 'white',
                borderRadius: '10px',
                overflow: 'hidden'
            }}
        >
            <CDBTableHeader>
                <tr style={{ textAlign: 'center', backgroundColor: '#3E3E3E', color: 'white' }}>
                    <th>ID</th>
                    <th>Cliente</th>
                    <th>Concepto</th>
                    <th>Monto</th>
                    <th>Frecuencia</th>
                    <th>Estado</th>
                    <th>Fecha Registro</th>
                    {<th>Acciones</th>}
                </tr>
            </CDBTableHeader>
            <CDBTableBody>
                {items.length > 0 ? (
                    items.map((item) => {
                        const { color, label } = getStatusConfig(item.status);
                        return (
                            <tr key={item.id} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                <td className="fw-bold" title={item.id} style={{ cursor: 'pointer' }}>
                                    {item.id ? (item.id.length > 10 ? `${item.id.substring(0, 8)}...` : item.id) : 'N/A'}
                                </td>
                                <td>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <span>{item.customerName}</span>
                                        {/*<small className="text-muted" style={{ fontSize: '11px' }}>{item.email}</small>*/}
                                    </div>
                                </td>
                                <td>{item.concept || 'N/A'}</td>
                                <td>{formatCurrency(item.amount)} {item.currency}</td>
                                <td>{item.frequency}</td>
                                <td>
                                    <span style={{ 
                                        padding: '4px 12px', 
                                        borderRadius: '20px', 
                                        backgroundColor: color, 
                                        color: 'white',
                                        fontSize: '12px',
                                        fontWeight: 'bold'
                                    }}>
                                        {label}
                                    </span>
                                </td>
                                <td>{formatDate(item.createdAt)}</td>
                                {
                                <td>
                                    {item.status !== 'Cancelado' && item.status !== 'CANCELLED' ? (
                                        <button 
                                            className="btn btn-sm btn-danger d-inline-flex align-items-center gap-1 text-white border-0 px-3 py-1"
                                            style={{ 
                                                borderRadius: '6px', 
                                                backgroundColor: '#DC3545',
                                                fontWeight: '600',
                                                fontSize: '13px',
                                                transition: 'background-color 0.2s'
                                            }}
                                            onClick={() => onCancel(item)}
                                        >
                                            <i className="bi bi-x-circle"></i>
                                            <span>Cancelar</span>
                                        </button>
                                    ) : (
                                        <span className="text-muted small">-</span>
                                    )}
                                </td>
                                }
                            </tr>
                        );
                    })
                ) : (
                    <tr>
                        <td colSpan="8" style={{ textAlign: 'center', padding: '40px', color: '#888' }}>
                            No se encontraron pagos recurrentes.
                        </td>
                    </tr>
                )}
            </CDBTableBody>
        </CDBTable>
    );
};
